import { Skeleton } from "antd"
import React from "react"

import type { AlbumListItem } from "../../../../../../Album/types/album.types.ts"
import { ALBUM_CARD_WITH } from "../album-card-width.ts"
import { AlbumCard } from "../AlbumCard/AlbumCard.tsx"
import { CreateAlbumCard } from "./CreateAlbumCard.tsx"

const gridStyle = {
  gridTemplateColumns: `repeat(auto-fill, minmax(${ALBUM_CARD_WITH}px, 1fr))`
}

export const AlbumsGridLoader = ({
  count = 4,
  className = ""
}: {
  count?: number
  className?: string
}) => (
  <div style={gridStyle} className={`grid gap-4 ${className}`.trimEnd()}>
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton.Node
        key={i}
        active
        style={{ width: "100%", height: "220px" }}
        className="w-full"
      />
    ))}
  </div>
)

interface AlbumsGridViewProps {
  albums: AlbumListItem[]
  createAllowed: boolean
  onCreateAlbumClick?: () => void
  onView?: (id: string) => void
  userId: string
  deleteAllowed: boolean
  deleteForeignAllowed: boolean
  onDeleteClick: (albumId: string) => void
  editAllowed: boolean
  onEditClick: (albumId: string) => void
}

export const AlbumsGridView = ({
  albums,
  createAllowed,
  onCreateAlbumClick,
  onView,
  userId,
  deleteAllowed,
  deleteForeignAllowed,
  onDeleteClick,
  editAllowed,
  onEditClick
}: AlbumsGridViewProps) => {
  return (
    <div style={gridStyle} className="grid gap-4">
      {createAllowed && (
        <div style={{ minHeight: 220 }}>
          <CreateAlbumCard onClick={onCreateAlbumClick} />
        </div>
      )}

      {albums.map((album) => (
        <AlbumCard
          key={album.id}
          album={album}
          onView={onView}
          userId={userId}
          deleteAllowed={deleteAllowed}
          deleteForeignAllowed={deleteForeignAllowed}
          onDeleteClick={onDeleteClick}
          editAllowed={editAllowed}
          onEditClick={onEditClick}
        />
      ))}
    </div>
  )
}
